import { equipmentKycApi } from '../api/modules/equipmentKyc.api';
import { getApiErrorMessage } from '../api/client';
import { USE_API } from '../config/api';

export async function listEquipmentKyc(params = {}) {
  if (!USE_API) {
    return { items: [], total: 0, page: 1, pageSize: params.pageSize || 20 };
  }
  try {
    return await equipmentKycApi.list(params);
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Failed to load Equipment KYC'));
  }
}

export async function getEquipmentKyc(id) {
  if (!USE_API) return null;
  try {
    return await equipmentKycApi.getById(id);
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Failed to load Equipment KYC'));
  }
}

export async function extractEquipmentKyc(id) {
  if (!USE_API) return null;
  try {
    return await equipmentKycApi.extractData(id);
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'AI extraction failed'));
  }
}

export async function updateEquipmentKyc(id, form) {
  if (!USE_API) return null;
  try {
    return await equipmentKycApi.update(id, form);
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Failed to update Equipment KYC'));
  }
}

export async function deleteEquipmentKyc(id) {
  if (!USE_API) return null;
  try {
    return await equipmentKycApi.remove(id);
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Failed to delete Equipment KYC'));
  }
}
